export const TASKS = [
  {
    id: 1,
    title: "Collect onboarding details",
    assignedTo: "Mayank",
    createdBy: "Pravin",
    status: "OPEN",
  },
  {
    id: 2,
    title: "Submit compliance form",
    assignedTo: "Sumit",
    createdBy: "Jayant",
    status: "SUBMITTED",
  },
  {
    id: 3,
    title: "Review signed contract",
    assignedTo: "Rahul",
    createdBy: "Amit",
    status: "COMPLETED",
  },
];

export const DOCUMENTS = [
  { id: 1, name: "contract.docx", status: "Uploaded" },
  { id: 2, name: "invoice_Q1.pdf", status: "Pending Review" },
];

export const ACTIVITY = [
  { id: 1, type: "task", text: "Sumit submitted compliance form", time: "5 hours ago" },
  { id: 2, type: "doc", text: "contract.docx uploaded", time: "1 day ago" },
  { id: 3, type: "task", text: "Mayank completed onboarding task", time: "2 days ago" },
];
